module.exports = __webpack_public_path__ + "img/ip.d4f78101.jpg";